function constructWhatsappLink(phone="",text="",api=true){
    if(phone.startsWith("0")){
      phone="62"+phone.substring(1)
    }
    text=encodeURIComponent(text)
    if(api){
      return "whatsapp://send/?"+(!!phone?("phone="+phone):"")+(!!text?("&text="+text):"")
    }else{
      return "https://web.whatsapp.com/send/?"+(!!phone?("phone="+phone):"")+(!!text?("&text="+text):"")
    }

  }
    
  function arrayContains(array,obj,field){
    if(!array||!obj||!field)return false
    var found = false;
    for(var i=0;i<array.length;i++){
        if(array[i][field]===obj[field]){
        found=true
        break
        }
    }
    return found
  }
  
  const UPPERCASE_CHAR_CODES = arrayFromLowToHigh(65, 90);
  const LOWERCASE_CHAR_CODES = arrayFromLowToHigh(97, 122);
  const NUMBER_CHAR_CODES = arrayFromLowToHigh(48, 57);
  const SYMBOL_CHAR_CODES = arrayFromLowToHigh(33, 47).concat(arrayFromLowToHigh(58, 64)).concat(arrayFromLowToHigh(91, 96)).concat(arrayFromLowToHigh(123, 126));
  
  const generatePassword = (characterAmount = 6, includeUppercase = true, includeLowercase = false, includeNumbers = true, includeSymbols = false) => {
    let charCodes = [];
    if (includeUppercase) charCodes = charCodes.concat(UPPERCASE_CHAR_CODES);
    if (includeLowercase) charCodes = charCodes.concat(LOWERCASE_CHAR_CODES);
    if (includeSymbols) charCodes = charCodes.concat(SYMBOL_CHAR_CODES);
    if (includeNumbers) charCodes = charCodes.concat(NUMBER_CHAR_CODES);
  
    if (charCodes.length === 0) {
      return "";
    }
  
    const passwordCharacters = [];
  
    for (let i = 0; i < characterAmount; i++) {
      const characterCode = charCodes[Math.floor(Math.random() * charCodes.length)];
      passwordCharacters.push(String.fromCharCode(characterCode));
    }
  
    return passwordCharacters.join('');
  };
  
  function arrayFromLowToHigh(low, high) {
    const array = [];
  
    for (let i = low; i <= high; i++) {
      array.push(i);
    }
  
    return array;
  }
  function numberToRupiah(number,prefix="Rp ",sufix=",00"){
    var res=""+(!!parseInt(number)?parseInt(number):0)
    var arr=res.split("")
    arr.reverse()
    var len=Math.trunc(arr.length /3)
    if(len>=1){
      var temp=""
      for(var i=0;i<arr.length;i++){
        if(i>0 && i % 3 === 0){
          temp= arr[i]+"."+temp
        }else{
          temp= arr[i]+temp
        }
      }
      res=temp
    }
    if(res.length<11){
      var add=11-res.length
      for(let i=0;i<add;i++){
        res=" "+res
      }
    }
    return prefix+res+sufix
  }
  function numberToRibuan(number){
    var res=""+(!!parseInt(number)?parseInt(number):0)
    var arr=res.split("")
    arr.reverse()
    var len=Math.trunc(arr.length /3)
    if(len>=1){
      var temp=""
      for(var i=0;i<arr.length;i++){
        if(i>0 && i % 3 === 0){
          temp= arr[i]+"."+temp
        }else{
          temp= arr[i]+temp
        }
      }
      res=temp
    }
    //if(res.length<11){
    //  var add=11-res.length
    //  for(var i=0;i<add;i++){
    //    res=" "+res
    //  }
    //}
    return res
  }

  var getURLParams = function (url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  function capWords(str){
    return str.replace(/\b\w/g,l=>l.toUpperCase())
  }

  function titleCase(str){
    return str.replace(/(^\s*\w|[.!?]\s*\w)/g,l=>l.toUpperCase())
  }
  
  function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      
      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }
  export {constructWhatsappLink,arrayContains,generatePassword,numberToRupiah,numberToRibuan,getURLParams,capWords,titleCase,copyTextToClipboard}